// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"725":"db96fc76","978":"f1901d91"}[chunkId] + ".js";
};